import {inject, onMounted} from 'vue';
import ymGoals from '../common/helpers/ymGoals.js';
import vkGoals from '../common/helpers/vkGoals.js';
import setMetricsTarget from '../common/helpers/setMetricsTarget.js';

export default function useTargetMetrics(yandexMetrics, vkMetrics) {
    const widgetId = inject('widgetId');
    const widgetType = inject('widgetType');
    const containerId = `${widgetType}-${widgetId}`;

    const initializeGoals = () => {
        ymGoals.forEach(item => {
            setMetricsTarget(
                yandexMetrics, [], item.targetClass, item.goalName, containerId,
            );
        });
        vkGoals.forEach(item => {
            setMetricsTarget(
                [], vkMetrics, item.targetClass, item.goalName, containerId,
            );
        })
    };

    onMounted(() => {
        initializeGoals();
    });
}
